<template>
  <v-card class="mx-auto fill-height d-flex flex-column">
    <v-card-title>
      <v-icon large left v-if="type == 'email'"> mdi-email </v-icon>
      <v-icon large left v-if="type == 'sms'"> mdi-message-text </v-icon>
      <span class="title font-weight-light">{{ title }}</span>
      <v-spacer></v-spacer>
      <v-tooltip bottom v-if="status_id == 1">
        <template v-slot:activator="{ on, attrs }">
          <v-btn v-bind="attrs" v-on="on" icon @click="edit" x-small>
            <EditIcon />
          </v-btn>
        </template>
        <span>Edit</span>
      </v-tooltip>
    </v-card-title>
    <v-card-text
      style="max-height: 120px"
      class="overflow-y-auto overflow-x-hidden no-background"
    >
      <h3 class="font-weight-light">{{ message }}</h3>
    </v-card-text>

    <v-spacer></v-spacer>
    <v-card-actions>
      <v-list-item class="grow">
        <v-row align="center">
          <v-icon class="mr-1">mdi-clock-outline</v-icon>
          <span class="subheading mr-2">{{ schedule_date }}</span>
          <v-spacer></v-spacer>

          <v-tooltip top v-if="status_id == 1">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                v-on="on"
                icon
                @click="deleteMessage"
                class=""
                x-small
              >
                <DeleteIcon />
              </v-btn>
            </template>
            Delete
          </v-tooltip>
        </v-row>
      </v-list-item>
    </v-card-actions>
  </v-card>
</template>

<script>
import EditIcon from "@/assets/images/misc/edit-icon.svg";
import DeleteIcon from "@/assets/images/misc/delete-icon.svg";

export default {
  components: { DeleteIcon, EditIcon },
  props: {
    title: { type: String, default: "" },
    message: { type: String, default: "" },
    type: { type: String, default: "sms" },
    schedule_date: { type: String, default: "2020-12-12 22:45:23" },
    id: { type: Number, default: 1 },
    status_id: { type: Number, default: 0 },
    marketing_customers: { type: Array, default: null },
    message_type: { type: String, default: "0" },
    from_age: { type: Number, default: 0 },
    interest: { type: String, default: "" },
    name_filter: { type: String, default: "" },
    email_filter: { type: String, default: "" },
    mobile_filter: { type: String, default: "" },
    customer_type: { type: String, default: "" },
    nationalities: {
      type: Array,
      default: () => {
        return [];
      },
    },

    year: { type: String, default: null },
    yearIndex: { type: Number, default: null },
    monthName: { type: String, default: "" },
    monthIndex: { type: Number, default: null },
  },

  methods: {
    edit() {
      this.$router.push({
        name: "EditAnnouncement",
        params: { type: this.type, id: this.id },
      });
    },

    deleteMessage() {
      this.$emit("delete", {
        id: this.id,
        year: this.year,
        yearIndex: this.yearIndex,
        monthName: this.monthName,
        monthIndex: this.monthIndex,
      });
    },
  },
};
</script>

<style></style>
